// extracted by mini-css-extract-plugin
module.exports = {"listCommend":"listCommend--3ZdZH","boxTitle":"boxTitle--1Zuyw","info":"info--2pwIc","high":"high--2GzTn","btns":"btns--2oIyQ"};